// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3sjWM","empty":"ModalGraph_empty__L7XtK"};